// @ts-strict-ignore
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, of, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import * as urltemplate from 'url-template';
import { LMValidateFieldResponse } from './lm-field-editor-dialog';
import { LMLoggerService } from '@services/lm-logger.service';

@Injectable()
export class LMFieldValidatorService {
  constructor(
    private http: HttpClient,
    private lmLoggerService: LMLoggerService,
  ) {
  }

  public fieldIsValid(value: string, busClassName: string, busListName: string, reportPersonalizationUrl: string): Observable<LMValidateFieldResponse> {
    if (!(value.trim().length > 0)) {
      return of({
        lplStatus: 'LPL_INVALID',
        message: {
          error: Soho.Locale.translate('Required')
        }
      } as LMValidateFieldResponse);
    }

    const formRequest = {
      requestType: 'validateField',
      param1: busClassName,
      param2: value,
      param3: busListName,
    };

    const headers = new HttpHeaders();
    headers.append('Content-Type', 'application/json;charset=utf-8');

    const compiledUrlTemplate = urltemplate.parse(reportPersonalizationUrl);

    const url = compiledUrlTemplate.expand({ resourceId: busClassName });

    return this.http.post<LMValidateFieldResponse>(url, JSON.stringify(formRequest), { headers }).pipe(
      map((response: LMValidateFieldResponse) => {
        if (response.message.error) {
          response.message.error = Soho.Locale.translate('ListPersonalizationAddFieldErrorMessage');
        }
        return response;
      }),
      catchError(error => this._handleError(error)));
  }

  public validatePeriodOperator(lplText: string, listSpec: LMListSpec, listUrlInfo: LMListUrlInfo): Observable<LMValidateFieldResponse> {
    if (!(lplText.trim().length > 0)) {
      return of({
        lplStatus: 'LPL_VALID',
        message: {}
      } as LMValidateFieldResponse);
    }

    const formRequest = {
      requestType: 'validatePeriodOperator',
      param1: listSpec.busClassSpec.name,
      param2: lplText,
    };

    const headers = new HttpHeaders();
    headers.append('Content-Type', 'application/json;charset=utf-8');

    const compiledUrlTemplate = urltemplate.parse(listUrlInfo.reportPersonalizationUrl);
    const url = compiledUrlTemplate.expand({ resourceId: listSpec.busClassSpec.name });

    return this.http.post<LMValidateFieldResponse>(url, JSON.stringify(formRequest), { headers }).pipe(
      map((response: LMValidateFieldResponse) => {
        if (response.lplStatus === 'LPL_INVALID') {
          response.message.error = Soho.Locale.translate('ListPersonalizationPeriodOperatorErrorMessage');
        }
        return response;
      }),
      catchError(error => this._handleError(error)));
  }

  private _handleError(error: Response) {
    // in a real world app, we may send the error to some remote logging infrastructure
    // instead of just logging it to the console
    this.lmLoggerService.log(error);
    return throwError(error || 'Server error');
  }
}
